import gql from 'graphql-tag';

export const NAME =
  'compositions_CaseAssetValidationPanel_searchCustomersQuery';

export default gql`
  query ${NAME} ($shipTo: String!) {
    searchCustomers(filters: { searchString: $shipTo }) {
      id
      shipTo
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseAssetValidationPanel/ValidateAssetModal/withSetCaseCustomerByShipTo/searchCustomersQuery.js